import ContactNameCell from "./ContactNameCell.js";

const ContactsColumnDefs = [
  {
    dataField: "name",
    caption: "Name",
    render: (rowData) => (
      <ContactNameCell rowData={rowData?.rowData || rowData} />
    ),
  },
  {
    dataField: "email",
    caption: "Email",
  },
  {
    dataField: "title",
    caption: "Title",
  },
  {
    dataField: "organization",
    caption: "Organization",
  },
  {
    dataField: "address",
    caption: "Address",
    visible: false,
  },
  {
    dataField: "city",
    caption: "City",
    visible: false,
  },
  {
    dataField: "state",
    caption: "State",
    visible: false,
  },
  {
    dataField: "zipcode",
    caption: "Zipcode",
    visible: false,
  },
  {
    dataField: "mobile_number",
    caption: "Mobile",
    visible: false,
  },
  {
    dataField: "office_number",
    caption: "Phone",
    visible: false,
  },
  {
    dataField: "contact_type",
    caption: "Type",
  },
  {
    dataField: "notes",
    caption: "Notes",
    visible: false,
  },
  {
    dataField: "unique_id",
    caption: "Unique ID",
    visible: false,
  },
];

export default ContactsColumnDefs;
